var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.95329C22 11.2412 19.371 13.9066 16.128 13.9066C15.0081 13.9066 13.9614 13.5887 13.0709 13.0371L10.8049 15.3346L11.5563 16.0966C11.9384 16.4841 11.9384 17.1123 11.5562 17.4997L10.9481 18.1163C10.5659 18.5038 9.94616 18.5038 9.56398 18.1162L8.81268 17.3543L8.03643 18.1413L9.47991 19.6045C9.86217 19.992 9.8622 20.6203 9.47998 21.0078L8.78796 21.7094C8.40579 22.0968 7.78619 22.0969 7.40399 21.7095L5.96037 20.2461L5.36271 20.8521C4.8222 21.4001 3.94588 21.4001 3.40538 20.8521C2.86488 20.3041 2.86487 19.4156 3.40538 18.8676L11.1136 11.0527C10.5695 10.1499 10.256 9.08871 10.256 7.95329C10.256 4.66538 12.885 2 16.128 2C19.371 2 22 4.66538 22 7.95329ZM19.064 7.95329C19.064 6.30933 17.7495 4.97664 16.128 4.97664C14.5065 4.97664 13.192 6.30933 13.192 7.95329C13.192 9.59724 14.5065 10.9299 16.128 10.9299C17.7495 10.9299 19.064 9.59724 19.064 7.95329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.074ae0029c70353c33934e79dc95aaa2.svg";
export { ForwardRef as ReactComponent };